import Headroom from 'headroom.js';

const header = document.querySelector('body > header');

if (header) {
    const headroom = new Headroom(header, {
        offset: 15,
        tolerance: {
            down: 10,
            up: 5,
        },
    });
    headroom.init();

    // Freeze headroom when mobile menu is open
    const $btnMobileMenu = document.querySelector('.mobile-menu-btn');
    if ($btnMobileMenu) {
        $btnMobileMenu.addEventListener('click', () => {
            if ($btnMobileMenu.classList.contains('is-open')) {
                header.classList.remove('mobile-menu-open');
                headroom.freeze();
            } else {
                header.classList.add('mobile-menu-open');
                setTimeout(() => headroom.unfreeze(), 350);
            }
        });
    }
}
